import {
    GET_ALL_PROVINCES,
    GET_CANTONES_BY_PROVINCE,
    GET_DISTRITOS_BY_CANTON, 
    GET_LOCATION_BY_BADGE,
    LOCA_LOADING,
    ADD_LOCATION,
    ADD_PROVINCE,
    ADD_CANTON,
    ADD_DISTRIC
  } from "../actions/MyLocationAction";
  
  
  const initialState = {
    provinces: [],
    cantones: [],
    districs: [],
    location:[],
    loading: false,
    add: false,
  };
  
  const UserAdmin = function(state = initialState, action) {
    switch (action.type) {
        case LOCA_LOADING: {
          return {
            ...state,
            loading: true,
            add: false
          };
        }
        case GET_ALL_PROVINCES: {
            return{
                ...state,
                provinces : [...action.data],
                loading: false,
                add : false,
            }
        }
        case GET_CANTONES_BY_PROVINCE: {
          return{
              ...state,
              cantones : [...action.data],
              loading: false
          }
        }
        case GET_DISTRITOS_BY_CANTON: {
          return{
              ...state,
              districs : [...action.data],
              loading: false
          }
        }
        case GET_LOCATION_BY_BADGE: {
          return{
              ...state,
              location : [...action.data],
              loading: false
          }
        }
        case ADD_LOCATION: {
          return {
            ...state,
            add : true,
            loading: false  
          };
        }
        case ADD_PROVINCE: {
          return {
            ...state,
            add : true,
            loading: false  
          };
        }
        case ADD_CANTON: {
          return {
            ...state,
            add : true,
            loading: false  
          };
        }
        case ADD_DISTRIC: {
          return {
            ...state,
            add : true,
            loading: false  
          };
        }
        default: {
            return state;
          }
        }
  }
  
  export default UserAdmin;
  